var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "rich-text-editor",
      class: { "rich-text-editor--resizable": _vm.resizable },
    },
    [
      _c("VueEditor", {
        attrs: {
          value: _vm.value,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          "editor-toolbar": _vm.toolbar,
          "use-custom-image-handler": _vm.allowImages,
        },
        on: {
          input: _vm.onInput,
          blur: function ($event) {
            return _vm.$emit("blur")
          },
          ready: _vm.onReady,
          "image-added": (...args) => _vm.$emit("image-added", ...args),
          "image-removed": function ($event) {
            return _vm.$emit("image-removed", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.linkTip
        ? _c(
            "div",
            {
              staticClass: "rich-text-editor__tip",
              class: { "rich-text-editor__tip--above": _vm.linkTip.above },
              style: _vm.tipStyle,
              on: {
                mouseenter: _vm.cancelTipHide,
                mouseleave: _vm.hideLinkTip,
              },
            },
            [
              _c("span", { staticClass: "rich-text-editor__tip-url" }, [
                _vm._v(_vm._s(_vm.linkTip.label)),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "rich-text-editor__tip-open",
                  attrs: {
                    href: _vm.linkTip.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    title: "Open in new tab",
                  },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "box-arrow-up-right", "font-scale": "0.9" },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("TextInputModal", {
        ref: "linkModal",
        attrs: {
          "modal-id": `rich-text-link-${_vm._uid}`,
          title: "Link URL",
          placeholder: "https://",
          size: "md",
        },
        on: { save: _vm.applyLink },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }